import { render } from "./BudgetModal.vue?vue&type=template&id=6d74fe35"
import script from "./BudgetModal.vue?vue&type=script&lang=js"
export * from "./BudgetModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__